/** Auth provider — initializes Firebase listener, gates authenticated routes. */

import { useEffect, type ReactNode } from "react";
import { useAuthStore } from "@/stores/auth";

export function AuthProvider({ children }: { children: ReactNode }) {
  const init = useAuthStore((s) => s.init);

  useEffect(() => {
    init();
  }, [init]);

  return <>{children}</>;
}
